import { Component, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { CommonService } from "../../../../views/services/common.service";
import { Country } from "../../../../views/shared/models/country";
import { ZipCode } from "../../../../views/shared/models/zipcode";
import { InternalLoggerService } from "../../accmgr/services/internal-audit-logger.service";
import { ExamineeInternalRequestService } from "../service/examinee-request.service";
import { ExamineeInternalForm } from "./examinee.form";
import { AppService } from "../../../../views/services/app.service";
import { HeaderService } from "../../../../../client/views/services/header.service";

@Component({
  templateUrl: "./examinee.component.html",
  styleUrls: ["./examinee.component.css"]
})
export class ExamineeInternalComponent implements OnInit {
  frmExamine: FormGroup;
  formSubmitted = false;
  isNational = false;
  isInternational = false;
  countries: Country[];
  zips: ZipCode[];
  formValue: any;
  personId: any;
  taaPin: any;
  studentDetails: any;
  oldFormValue: any;
  public user: string;
  public zipCode1: any;
  public zipCode2: any;
  public city1: any;
  public city2: any;
  public state1: any;
  public state2: any;
  public msart1041: boolean = false;

  constructor(
    private examineeForm: ExamineeInternalForm,
    private examineeRequestService: ExamineeInternalRequestService,
    private internalLoggerService: InternalLoggerService,
    private appService: AppService,
    public router: Router,
    private _commonService: CommonService,
    public headerService: HeaderService
  ) {
    this.frmExamine = this.examineeForm.build();
  }

  ngOnInit() {
    if (sessionStorage.getItem("internalStudentDetails")) {
      this.studentDetails = JSON.parse(
        sessionStorage.getItem("internalStudentDetails")
      );
    }
    this.personId = this.studentDetails.personId;
    Observable.forkJoin([
      this.examineeRequestService.getCountries(),
      this.examineeRequestService.getPerson(this.personId),
      this.examineeRequestService.getPersonName(this.personId),
      this.examineeRequestService.getPersonAddress(this.personId)
    ]).subscribe(([countries, person, personName, personAddress]) => {
      this.countries = <Country[]>countries;
      const DOB = moment(person["body"][0]["BIRTH_DT"].substr(0, 10)).format(
        "L"
      );
      const formValue = {
        StudentId: person["body"][0]["STATE_SYSTEM_ID"]
          ? person["body"][0]["STATE_SYSTEM_ID"]
          : "",
        personId: personName["body"][0]["PERSON_ID"],
        ACTId: person["body"][0]["ACT_ID"] ? person["body"][0]["ACT_ID"] : "",
        EXTPersonId: person["body"][0]["EXT_PERSON_ID"]
          ? person["body"][0]["EXT_PERSON_ID"]
          : "",
        FirstName: personName["body"][0]["FIRST_NM"],
        MiddleName: personName["body"][0]["MIDDLE_NM"]
          ? personName["body"][0]["MIDDLE_NM"]
          : "",
        LastName: personName["body"][0]["LAST_NM"],
        DOB: DOB,
        personAddressID: personAddress["body"][0]["PERSON_ADDRESS_ID"],
        personNameID: personName["body"][0]["PERSON_NAME_ID"],
        Country: personAddress["body"][0]["COUNTRY_CD"],
        Address1: personAddress["body"][0]["STREET_1_AD"],
        Address2: personAddress["body"][0]["STREET_2_AD"]
          ? personAddress["body"][0]["STREET_2_AD"]
          : ""
      };
      this.taaPin = person["body"][0]["ACCOMMS_PIN"];

      const countryIndex = this.countries.findIndex(
        value => value.id === personAddress["body"][0]["COUNTRY_CD"]
      );
      if (countryIndex !== -1) {
        this.getCountrySelection(countryIndex + 1);
        if (this.isInternational) {
          formValue["InternationalZip"] =
            personAddress["body"][0]["ZIP_POSTAL_CD"];
          formValue["InternationalCity"] = personAddress["body"][0]["CITY_NM"];
          this.zipCode1 = formValue["InternationalZip"];
          this.city1 = formValue["InternationalCity"];
        } else if (this.isNational) {
          formValue["NationalZip"] = personAddress["body"][0]["ZIP_POSTAL_CD"];
          formValue["NationalCity"] = personAddress["body"][0]["CITY_NM"];
          formValue["NationalState"] = personAddress["body"][0]["STATE_CD"]
            ? personAddress["body"][0]["STATE_CD"]
            : "";
          this.zipCode1 = formValue["NationalZip"];
          this.city1 = formValue["NationalCity"];
          this.state1 = formValue["NationalState"];
          this.lookupZipCode(personAddress["body"][0]["ZIP_POSTAL_CD"]);
        }
      }
      this.frmExamine.patchValue(formValue);
      this.oldFormValue = formValue;
    });

    this.headerService
      .getConfigPropertyValue("msart_1041")
      .subscribe((resp: any) => {
        if (resp.body === true) {
          this.msart1041 = true;
        }
      });
  }

  getCountrySelection(index) {
    if (index > 0) {
      index = index - 1;
      const value = this.countries[index].id;
      if (value === "US") {
        this.isNational = true;
        this.isInternational = false;
        this.frmExamine.get("NationalZip").setValidators([Validators.required]);
        this.frmExamine
          .get("NationalState")
          .setValidators([Validators.required]);
        this.frmExamine
          .get("NationalCity")
          .setValidators([Validators.required]);
        this.frmExamine.get("InternationalZip").setValidators([]);
        this.frmExamine.get("InternationalCity").setValidators([]);
      } else if (value) {
        this.isNational = false;
        this.isInternational = true;
        this.frmExamine.get("InternationalZip").setValidators([]);
        this.frmExamine
          .get("InternationalCity")
          .setValidators([Validators.required]);
        this.frmExamine.get("NationalZip").setValidators([]);
        this.frmExamine.get("NationalState").setValidators([]);
        this.frmExamine.get("NationalCity").setValidators([]);
      } else {
        this.isNational = false;
        this.isInternational = false;
      }
      this.frmExamine.patchValue({
        Address1: "",
        Address2: "",
        InternationalZip: "",
        InternationalCity: "",
        NationalZip: "",
        NationalState: "",
        NationalCity: ""
      });

      this.frmExamine.updateValueAndValidity();
    }
  }
  cancel() {
    this.router.navigate(["/exAccreqdetails"]);
  }

  saveExamineeData(proceed: boolean): void {
    this.formSubmitted = true;
    this.appService
      .getUserProfile()
      .then(userProfile => (this.user = userProfile.loggedInUser));
    if (this.frmExamine.valid) {
      const newActId: string = this.frmExamine.get("ACTId").value;
      if (newActId) {
        this.frmExamine.controls["ACTId"].setValue(newActId.replace(/-/gi, ""));
      }
      const extPersonId: string = this.frmExamine.get("EXTPersonId").value;
      if (extPersonId) {
        // Get ACT id since the new ext person Id is provided
        this._commonService
          .getActIdByExternalId(extPersonId)
          .subscribe((resp: any) => {
            if (resp.body !== "Not found") {
              this.frmExamine.controls["EXTPersonId"].setValue(extPersonId);
              this.saveExaminee();
            } else {
              this.frmExamine.controls["EXTPersonId"].setErrors({
                invalidPersonIdPattern: true
              });
              return;
            }
          });
      } else {
        this.saveExaminee();
      }
    }
  }

  saveExaminee(): void {
    const req = Object.assign(this.frmExamine.value);
    if (req.NationalZip) {
      this.zipCode2 = req.NationalZip;
      this.city2 = req.NationalCity;
      this.state2 = req.NationalState;
    } else {
      this.zipCode2 = req.InternationalZip;
      this.city2 = req.InternationalCity;
    }
    const loggerModel = {
      MODULE_ID: "REVIEW",
      CATEGORY_ID: "EXAMINEE_DEMOGRAPHIC_UPDATE",
      COMPONENT_ID: "FUNCTIONALITY_EDIT_EXAMINEE_DETAILS_PAGE",
      CREATED_BY_DS: this.user,
      MESSAGE_TX:
        " Demographic Details Updated for " +
        " " +
        this.studentDetails.firstNm +
        " " +
        this.studentDetails.lastNm,
      REFERENCE_ID: this.personId,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.user,
      USER_DATA_VAL:
        "Person_Id: " +
        this.personId +
        " BEFORE_IMAGE:{ First Name:" +
        " " +
        this.oldFormValue.FirstName +
        ",  MI:" +
        this.oldFormValue.MiddleName +
        ",  Last Name:" +
        this.oldFormValue.LastName +
        ",  DOB:" +
        this.oldFormValue.DOB +
        ",  Address1:" +
        this.oldFormValue.Address1 +
        ",  Address2:" +
        this.oldFormValue.Address2 +
        ",  City:" +
        this.city1 +
        ",  State:" +
        this.state1 +
        "  Zip_Postal:" +
        this.zipCode1 +
        ",  Country:" +
        this.oldFormValue.Country +
        ",  ACT ID:" +
        this.oldFormValue.ACTId +
        ",  State Student Id:" +
        this.oldFormValue.StudentId +
        " }  AFTER_IMAGE:{ First Name:" +
        req.FirstName +
        ",  MI:" +
        req.MiddleName +
        ",  Last Name:" +
        req.LastName +
        ",  DOB:" +
        moment(req.DOB, "DD/MM/YYYY").format("DD/MM/YYYY") +
        ",  Address1:" +
        req.Address1 +
        ",  Address2:" +
        req.Address2 +
        ",  City:" +
        this.city2 +
        ",  State:" +
        this.state2 +
        "  Zip_Postal:" +
        this.zipCode2 +
        ",  Country:" +
        req.Country +
        ",  ACT ID:" +
        req.ACTId +
        ",  State Student Id:" +
        req.StudentId +
        " }"
    };
    Observable.forkJoin([
      this.examineeRequestService.updatePerson(req),
      this.examineeRequestService.updatePersonName(req),
      this.examineeRequestService.updatePersonAddress(req)
    ]).subscribe(([res]) => { });
    this.internalLoggerService
      .updateAuditLogger(loggerModel)
      .subscribe(success => { }, err => { });
    this.router.navigate(["/exAccreqdetails"]);
  }

  lookupZipCode(zipcode: string) {
    this.frmExamine.patchValue({
      NationalCity: "",
      NationalState: undefined
    });
    this.examineeRequestService.lookupZipCode(zipcode).subscribe(zips => {
      this.zips = zips;
      this.zips.forEach(zip => {
        if (zip.preferredLastLineCityStateKey === zip.cityStateKey) {
          this.frmExamine.patchValue({
            NationalCity: zip.cityStateName,
            NationalState: zip.stateAbbrv
          });
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/edit-examinee/examinee.component.ts